import { TextField } from "@mui/material";
import axios from "axios";
import { useAtom, useAtomValue } from "jotai";
import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import {
  HardSkillsFilter,
  LocationFilter,
  SoftSkillsFilter,
  UsedLanguagesFilter,
} from "../../../components/common";
import ProjectDeadline from "../../../components/Filters_Projects/ProjectDeadlineFilter";
import AreaOfExperties from "../../../components/Filters_Teammates/AreaOfExpertiesFilter";
import ForGratification from "../../../components/Filters_Teammates/ForGratificationFilter";
import OfferedGratification from "../../../components/Filters_Teammates/OfferedGratificationFilter";
import OfferedWorkingType from "../../../components/Filters_Teammates/OfferedWorkingTypeFilter";
import ProjectType from "../../../components/Filters_Teammates/ProjectTypeFilter";
import Availability from "../../../components/Filters_Teammates/RequiredAvailabilityFilter";
import BizOrTechRole from "../../../components/Filters_Teammates/RequiredBizOrTechRoleFilter";
import TeammateNickname from "../../../components/Filters_Teammates/TeammateNicknameFilter";
import ToolsExperienceFilter from "../../../components/Filters_Teammates/ToolsExperienceFilter";
import Page from "../../../components/Page";
import "../../../sass/components/newInputForm/CarouselPage.scss";
import { url } from "../../../url";
import { useDataFromEditTeammate } from "../../../utils/useDataFromEditTeammate";
import { useOpenCloseFiltersEditTeammate } from "../../../utils/useOpenCloseFiltersEditTeammate";
import {
  bizOrTechRoleAtomLeftValue,
  bizOrTechRoleAtomRightValue,
  descriptionAtom,
  forGratificationAtom,
  hardSkillsAtom,
  locationsAtom,
  nicknameAtom,
  offeredGratificationAtom,
  offeredWorkingTypeActiveOptionsAtom,
  offeredWorkingTypeAtomNewArray,
  openAtom,
  pageAtom,
  projectDeadlineAtom,
  projectTypeAtom,
  requiredAreaOfExpertiseAtom,
  requiredAvailabilityAtomEndValue,
  requiredAvailabilityAtomOption,
  requiredAvailabilityAtomStartValue,
  softSkillsAtom,
  toolsExperienceAtom,
  toolsExperienceOptionViewsAtom,
  usedLanguagesAtom,
} from "../atoms/EditTeammateAtomGlobal";

const EditTeammate = () => {
  const [page, setPage] = useAtom(pageAtom);
  // Page 1
  const [nickname, setNickname] = useAtom(nicknameAtom);
  const [toolsExperience, setToolsExperience] = useAtom(toolsExperienceAtom);
  const [toolsExperienceOptionViews, setToolsExperienceOptionViews] = useAtom(
    toolsExperienceOptionViewsAtom
  );
  const [projectType, setProjectType] = useAtom(projectTypeAtom);
  const [projectDeadline, setProjectDeadline] = useAtom(projectDeadlineAtom);
  const [offeredGratification, setOfferedGratification] = useAtom(
    offeredGratificationAtom
  );
  const [softSkills, setSoftSkills] = useAtom(softSkillsAtom);
  const [requiredAreaOfExpertise, setRequiredAreaOfExpertise] = useAtom(
    requiredAreaOfExpertiseAtom
  );
  const [forGratification, setForGratification] = useAtom(forGratificationAtom);

  // Page 2
  const [hardSkills, setHardSkills] = useAtom(hardSkillsAtom);
  const [offeredWorkingTypeNewArray, setOfferedWorkingTypeNewArray] = useAtom(
    offeredWorkingTypeAtomNewArray
  );
  const [offeredWorkingTypeActiveOptions, setOfferedWorkingTypeActiveOptions] =
    useAtom(offeredWorkingTypeActiveOptionsAtom);

  // Page 3
  const [usedLanguages, setUsedLanguages] = useAtom(usedLanguagesAtom);
  const [bizOrTechRoleLeftValue, setBizOrTechRoleLeftValue] = useAtom(
    bizOrTechRoleAtomLeftValue
  );
  const [bizOrTechRoleRightValue, setBizOrTechRoleRightValue] = useAtom(
    bizOrTechRoleAtomRightValue
  );
  const [requiredAvailabilityStartValue, setRequiredAvailabilityStartValue] =
    useAtom(requiredAvailabilityAtomStartValue);
  const [requiredAvailabilityEndValue, setRequiredAvailabilityEndValue] =
    useAtom(requiredAvailabilityAtomEndValue);
  const [requiredAvailabilityOption, setRequiredAvailabilityOption] = useAtom(
    requiredAvailabilityAtomOption
  );
  const [locations, setLocations] = useAtom(locationsAtom);
  const [description, setDescription] = useAtom(descriptionAtom);
  const data = useDataFromEditTeammate();
  const navigate = useNavigate();

  const openFilters = useAtomValue(openAtom);
  const enableAndResetFilters = useOpenCloseFiltersEditTeammate();

  useEffect(() => {
    const fetchData = async () => {
      const token = localStorage.getItem("token");
      const teammateProfile = await axios.get(url + "/user/myTeammate", {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
      });
      // Page 1 set
      setNickname(teammateProfile.data.userTeammateProfile.nickname);
      const toolsExperienceArr =
        teammateProfile.data.userTeammateProfile.toolsExperience;
      const stringArray =
        toolsExperienceArr.length > 0
          ? toolsExperienceArr.map((obj: any) => obj.tool)
          : [];
      setToolsExperience(stringArray);
      setProjectType(teammateProfile.data.userTeammateProfile.projectType);
      setOfferedGratification(
        teammateProfile.data.userTeammateProfile.offeredGratification
      );
      setSoftSkills(teammateProfile.data.userTeammateProfile.softSkills);
      setRequiredAreaOfExpertise(
        teammateProfile.data.userTeammateProfile.areaOfExpertise
      );
      setForGratification(
        teammateProfile.data.userTeammateProfile.forGratification
      );

      // Page 2 set
      setHardSkills(teammateProfile.data.userTeammateProfile.hardSkills);
      var newArray = [];
      var activeOptions = [];
      if (teammateProfile.data.userTeammateProfile.workingTypeRemote) {
        newArray.push("Remote");
        activeOptions.push(true);
      } else {
        activeOptions.push(false);
      }
      if (teammateProfile.data.userTeammateProfile.workingTypeOffice) {
        newArray.push("Office");
        activeOptions.push(true);
      } else {
        activeOptions.push(false);
      }
      setOfferedWorkingTypeNewArray(newArray);
      setOfferedWorkingTypeActiveOptions(activeOptions);

      // Page 3 set
      setUsedLanguages(teammateProfile.data.userTeammateProfile.usedLanguages);
      setBizOrTechRoleLeftValue(
        teammateProfile.data.userTeammateProfile.bizRole
      );
      setBizOrTechRoleRightValue(
        teammateProfile.data.userTeammateProfile.techRole
      );
      setRequiredAvailabilityStartValue(
        teammateProfile.data.userTeammateProfile.availabilityFrom
      );
      setRequiredAvailabilityEndValue(
        teammateProfile.data.userTeammateProfile.availabilityTo
      );
      setRequiredAvailabilityOption(
        teammateProfile.data.userTeammateProfile.availabilityType
      );
      setLocations(teammateProfile.data.userTeammateProfile.locations);
      setDescription(teammateProfile.data.userTeammateProfile.description);
    };
    fetchData();
  }, []);

  const onClickSubmitButton = async () => {
    const token = localStorage.getItem("token");
    if (!data.workingTypeRemote) {
      data.workingTypeRemote = false;
    }
    if (!data.workingTypeOffice) {
      data.workingTypeOffice = false;
    }
    try {
      const res = await axios.put(url + "/teammate/editTeammate", data, {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
      });
      console.log(res.data);
      navigate(`/skillers/my`);
    } catch (err) {
      console.log(err);
    }
  };

  return (
    <Page>
      <div style={{ width: "100%", padding: "20px" }}>
        <div className="page1_component" style={{ maxWidth: "100%" }}>
          <div
            className="columns_container"
            style={{
              display: "flex",
              // flexDirection: "row",
              gap: "25px",
              width: "70%", // Make the container take the full width
            }}
          >
            <div
              className="column"
              style={{
                display: "flex",
                flexDirection: "column",
                gap: "25px",
                flex: 1, // Both columns take equal space
              }}
            >
              {/* OBLIGATORY FIELDS*/}
              <TeammateNickname
                teammateNickname={nickname}
                setTeammateNickname={setNickname}
              />
              <ToolsExperienceFilter
                pickedOptions={toolsExperience}
                setPickedOptions={setToolsExperience}
                optionViews={toolsExperienceOptionViews}
                setOptionViews={setToolsExperienceOptionViews}
                show={openFilters.toolsExperience}
                setShow={enableAndResetFilters}
                displayColumn={true}
                isAdd={true}
              />
              <ProjectType
                pickedOptions={projectType}
                setPickedOptions={setProjectType}
                show={openFilters.projectType}
                setShow={enableAndResetFilters}
                displayColumn={true}
                isAdd={true}
              />
              <OfferedGratification
                pickedOptions={offeredGratification}
                setPickedOptions={setOfferedGratification}
                show={openFilters.offeredGratification}
                setShow={enableAndResetFilters}
                displayColumn={true}
                isAdd={true}
              />
              <ForGratification
                pickedOptions={forGratification}
                setPickedOptions={setForGratification}
                show={openFilters.forGratification}
                setShow={enableAndResetFilters}
                displayColumn={true}
                isAdd={true}
              />
              {/* OPTIONAL */}
              <AreaOfExperties
                pickedOptions={requiredAreaOfExpertise}
                setPickedOptions={setRequiredAreaOfExpertise}
                show={openFilters.requiredAreaOfExpertise}
                setShow={enableAndResetFilters}
                displayColumn={true}
                isAdd={true}
              />
              <HardSkillsFilter
                pickedOptions={hardSkills}
                setPickedOptions={setHardSkills}
                show={openFilters.hardSkills}
                setShow={enableAndResetFilters}
                displayColumn={true}
                isAdd={true}
              />
              {/* Willing to Collab Until */}

              <SoftSkillsFilter
                pickedOptions={softSkills}
                setPickedOptions={setSoftSkills}
                show={openFilters.softSkills}
                setShow={enableAndResetFilters}
                displayColumn={true}
                isAdd={true}
              />
              <ProjectDeadline
                value={projectDeadline}
                setValue={setProjectDeadline}
                open={openFilters.projectDeadline}
                setOpen={enableAndResetFilters}
                showFilterType={false}
                isAdd={true}
              />
            </div>

            <div
              className="column"
              style={{
                display: "flex",
                flexDirection: "column",
                gap: "25px",
                flex: 1,
              }}
            >
              <BizOrTechRole
                leftValue={bizOrTechRoleLeftValue}
                setLeftValue={setBizOrTechRoleLeftValue}
                rightValue={bizOrTechRoleRightValue}
                setRightValue={setBizOrTechRoleRightValue}
                open={openFilters.bizOrTech}
                setOpen={enableAndResetFilters}
                isAdd={true}
              />

              <Availability
                value={requiredAvailabilityStartValue}
                setValue={setRequiredAvailabilityStartValue}
                open={openFilters.requiredAvailability}
                setOpen={enableAndResetFilters}
                isAdd={true}
              />

              <OfferedWorkingType
                newArray={offeredWorkingTypeNewArray}
                setNewArray={setOfferedWorkingTypeNewArray}
                activeOptions={offeredWorkingTypeActiveOptions}
                setActiveOptions={setOfferedWorkingTypeActiveOptions}
                show={openFilters.offeredWorkingType}
                setShow={enableAndResetFilters}
                isAdd={true}
              />

              <LocationFilter
                pickedOptions={locations}
                setPickedOptions={setLocations}
                show={openFilters.locations}
                setShow={enableAndResetFilters}
                displayColumn={true}
                isAdd={true}
              />

              <UsedLanguagesFilter
                pickedOptions={usedLanguages}
                setPickedOptions={setUsedLanguages}
                show={openFilters.usedLanguages}
                setShow={enableAndResetFilters}
                displayColumn={true}
                isAdd={true}
              />

              <TextField
                name="description"
                placeholder="Description"
                multiline
                rows={8}
                maxRows={10}
                style={{ backgroundColor: "white" }}
                value={description}
                onChange={(event) => {
                  setDescription(event.target.value);
                }}
              />
            </div>
          </div>
        </div>
        <div className="buttons_container">
          <div>
            <button className="submit_btn" onClick={onClickSubmitButton}>
              Submit
            </button>
          </div>
        </div>
      </div>
    </Page>
  );
};

export default EditTeammate;
